import * as React from "react";
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList } from "react-window";
import { Button } from "semantic-ui-react";

import { UserData } from "../func/generateUsers";

export default function PreviewView(props: { users: UserData }) {
  const listRef = React.createRef<FixedSizeList>();

  function gotoTop() {
    if (listRef.current) {
      listRef.current.scrollToItem(0);
    }
  }

  function gotoBottom() {
    if (listRef.current) {
      listRef.current.scrollToItem(props.users.length);
    }
  }

  return (
    <>
      <Button.Group fluid basic>
        <Button onClick={gotoTop}>Scroll to Top</Button>
        <Button onClick={gotoBottom}>Scroll to End</Button>
      </Button.Group>
      <div style={{ marginTop: "1em", minHeight: "40em" }}>
        <AutoSizer>
          {({ height, width }) => (
            <FixedSizeList
              width={width}
              height={height}
              itemData={props.users}
              itemSize={24}
              itemCount={props.users.length}
              ref={listRef}
            >
              {({ data, index, style }) => (
                <div
                  style={{
                    ...style,
                    whiteSpace: "nowrap",
                    backgroundColor: index % 2 === 0 ? "#dddddd" : "white",
                    width: "initial",
                  }}
                >
                  <code>{JSON.stringify(data[index])}</code>
                </div>
              )}
            </FixedSizeList>
          )}
        </AutoSizer>
      </div>
    </>
  );
}
